import React from "react";
import * as Mui from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { designColors } from "services/constants/designTokens";

// Small contextual note box used under a view panel's REQUEST STATUS section
// (e.g. Leave's "will be marked Completed after the leave period ends", or
// an "edit/cancel this request" hint). Generic on purpose — title/body are
// plain strings — but only wired up for Leave today since it's the only
// request type with a clear post-approval lifecycle stage (Completed).
// `action` (optional) sits at the right end, e.g. a Refresh button.
export const RequestInfoBanner = ({ title, body, tone = "info", action }) => {
  if (!title && !body) return null;
  const toneColors =
    tone === "warning"
      ? { bg: "#FFF4CC", border: "#F2D680", icon: "#A15C00", text: "#A15C00" }
      : tone === "purple"
        ? { bg: "#F5F0FF", border: "#E9D7FE", icon: "#6D5BD0", text: "#4C3FA3" }
        : tone === "danger"
          ? { bg: "#FFF1F3", border: "#FECDD3", icon: "#E11D48", text: "#BE123C" }
          : { bg: designColors.tealTint, border: "#B7E4DB", icon: designColors.tealDark, text: designColors.tealDark };

  return (
    <Mui.Box
      sx={{
        p: 1.5,
        borderRadius: 2,
        backgroundColor: toneColors.bg,
        border: `1px solid ${toneColors.border}`,
        display: "flex",
        gap: 1,
        alignItems: "flex-start",
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 18, color: toneColors.icon, mt: "1px" }} />
      <Mui.Box sx={action ? { flex: 1, minWidth: 0 } : undefined}>
        {title ? (
          <Mui.Typography sx={{ fontWeight: 700, fontSize: 13, color: toneColors.text }}>
            {title}
          </Mui.Typography>
        ) : null}
        {body ? (
          <Mui.Typography sx={{ fontSize: 12.5, color: toneColors.text, mt: 0.25 }}>
            {body}
          </Mui.Typography>
        ) : null}
      </Mui.Box>
      {action ? (
        <Mui.Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexShrink: 0, alignSelf: "center" }}>
          {action}
        </Mui.Box>
      ) : null}
    </Mui.Box>
  );
};

export default RequestInfoBanner;
